@if (organisation; as currentOrganisation) {
    @if (link$ | async; as link) {
        <a [routerLink]="link.path"
           [queryParams]="link.queryParams">{{ currentOrganisation.name }}</a>
    }
} @else {
    N/A
}
